import { createSelector } from 'reselect';
import { dataFormatterUtils } from '../../../utils';

const getBrokenRounds = (state: any) => state.brokenRoundsReducer.data;
const getTotalNumberOfRounds = (state: any) => state.brokenRoundsReducer.totalNumberOfElements;
const getSessionIds = (state: any) => state.brokenRoundsReducer.sessionIds;
const getRoundUuids = (state: any) => state.brokenRoundsReducer.roundUuids;
const getBrokenRoundsMeta = (state: any) => state.brokenRoundsReducer.metadata;
const getStatusHistory = (state: any) => state.brokenRoundsReducer.statusHistory;
const getJobStatus = (state: any) => state.brokenRoundsReducer.isJobRunning;
const getJobUntilTime = (state: any) => state.brokenRoundsReducer.jobFinishUntil;
const getPendingJob = (state: any) => state.brokenRoundsReducer.pendingJob;
const getPendingBatch = (state: any) => state.brokenRoundsReducer.pendingBatch;
const getJobStatusInFlight = (state: any) => state.brokenRoundsReducer.jobStatusInFlight;
const getJobStatusSeq = (state: any) => state.brokenRoundsReducer.jobStatusSeq;
const getJobStatusFailures = (state: any) => state.brokenRoundsReducer.jobStatusFailures;
const getCompletedJobsCount = (state: any) => state.brokenRoundsReducer.completedJobsCount;

export const getBrokenRoundsData = createSelector(
    getBrokenRounds,
    (state) => state && dataFormatterUtils.getFormattedDataForCP(state),
);
export const getBrokenRoundsMetadata = createSelector(getBrokenRoundsMeta, (state) => state);

export const getTotalNumberOfRoundsData = createSelector(getTotalNumberOfRounds, (state) => state);
export const getSessionIdsData = createSelector(getSessionIds, (state) => state);
export const getRoundUuidsData = createSelector(getRoundUuids, (state) => state);
export const getStatusHistoryData = createSelector(
    getStatusHistory,
    (state) => state && dataFormatterUtils.getFormattedDataForCP(state),
);
export const getJobStatusData = createSelector(getJobStatus, (state) => state);
export const getJobUntilTimeData = createSelector(getJobUntilTime, (state) => state);
export const getPendingJobData = createSelector(getPendingJob, (state) => state);
export const getPendingBatchData = createSelector(getPendingBatch, (state) => state);
export const getJobStatusInFlightData = createSelector(getJobStatusInFlight, (state) => state);
export const getJobStatusSeqData = createSelector(getJobStatusSeq, (state) => state);
export const getJobStatusFailuresData = createSelector(getJobStatusFailures, (state) => state);
export const getCompletedJobsCountData = createSelector(getCompletedJobsCount, (state) => state);
